module.exports = __webpack_public_path__ + "static/media/mobile-active.cd2ef983.svg";